export default {
  text: "Wijzig het formaat doormiddel van de pijl in de rechteronderhoek. Verwijder een widget doormiddel van de prullenbak knop.",
}
